import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactD4PlumbingHeating from "./sections/ContactD4PlumbingHeating";
import SendUsAMessage from "./sections/SendUsAMessage";
import AreasCoveredAcrossDublin from "./sections/AreasCoveredAcrossDublin";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactD4PlumbingHeating />
      <SendUsAMessage />
      <AreasCoveredAcrossDublin />
      <Footer />
    </div>;
}